import React, { useEffect, useState } from "react";
// import "./GotraKuldevi.css";
import "../styles/GotraKuldevi.css";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import config from "../services/config";
import Loader from "../utilities/Loader";
import { showAlert } from "../utilities/alertService";
import KuldeviProfile from "./KuldeviProfile";
import KuldeviDetails from "./KuldeviDetails";

const GotraKuldevi = () => {
    const [gotraList, setGotraList] = useState([]);
    const [kuldeviList, setKuldeviList] = useState([]);
    const [heritageList, setHeritageList] = useState([]);
    const [gotraPdf, setGotraPdf] = useState(null);
    const [kuldevipdf, setKuldeviPdf] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedKuldeviId, setSelectedKuldeviId] = useState(null);

    const fetchGotraList = async () => {
        try {
            setLoading(true);
            const payload = { company_id: 1 };
            const res = await config.getGotraList(payload);

            if (res?.status === true) {
                setGotraList(res.data);
            }
        } catch (error) {
            console.error("❌ Error fetching Gotra list:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchKuldeviList = async () => {
        try {
            setLoading(true);
            const payload = { company_id: 1 };
            const res = await config.getKuldeviListForCustomer(payload);

            if (res?.status === true) {
                setKuldeviList(res.data);
            }
        } catch (error) {
            console.error("❌ Error fetching Kuldevi list:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchGotraPdf = async () => {
        try {
            setLoading(true);
            const payload = { company_id: 1 };
            const res = await config.downloadGotraPdf(payload);

            if (res?.status === true && res?.pdf_base64) {
                setGotraPdf(res.pdf_base64);
            }
        } catch (error) {
            console.error("❌ Error downloading Gotra PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchKuldeviPdf = async () => {
        try {
            setLoading(true);
            const payload = { company_id: 1 };
            const res = await config.downloadKuldeviPdf(payload);

            if (res?.status === true && res?.pdf_base64) {
                setKuldeviPdf(res.pdf_base64);
            }
        } catch (error) {
            console.error("❌ Error downloading Kuldevi PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const getCategoeryData = async () => {
        try {
            setLoading(true);
            const payload = {
                company_id: 1,
                category_id: 100, // Example category ID
            };
            const heritageRes = await config.getResourceData(payload);
            console.log("heritageRes:", heritageRes);
            if (heritageRes?.success === true && heritageRes.data?.length > 0) {
                setHeritageList(heritageRes.data);

            } else {
                showAlert("error", "Failed to fetch Hamari dharohar data");
            }
        } catch (error) {
            console.error("Error fetching category data:", error);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGotraList();
        fetchKuldeviList();
        getCategoeryData();
    }, []);

   
    const handleDownload = async (item) => {
        setLoading(true);
        try {
            // 🔹 Step 1 — Fetch data from API
            const payload = { id: item.id };
            const response = await config.getBookImgPdfServer(payload);

            // ✅ Step 2 — Validate response
            if (!response?.success || !response.data || response.data.length === 0) {
                showAlert("error", "No image or PDF found for this record.");
                return;
            }

            // 🔹 Step 3 — Extract file URL
            const fileData = response.data[0];
            const fileUrl = fileData.image_url; // ✅ server URL

            if (!fileUrl) {
                showAlert("error", "File URL missing.");
                return;
            }

            // 🔹 Step 4 — Open file in new tab (PDF/Image)
            window.open(fileUrl, "_blank");

            showAlert("success", "File is opened in a new tab.");
        } catch (error) {
            console.error("Error fetching book data:", error);
            showAlert("error", "Failed to open file.");
        } finally {
            setLoading(false);
        }
    };

    // const handlePdfDownload = (pdfData, fileName = "File.pdf") => {
    //     try {
    //         
    //         if (!pdfData) {
    //             showAlert("error", "No PDF data available to download.");
    //             return;
    //         }

    //         // Remove possible Base64 prefixes like "data:application/pdf;base64,"
    //         const base64String = pdfData.includes(",")
    //             ? pdfData.split(",")[1]
    //             : pdfData;

    //         // Decode Base64 and create Blob
    //         const byteCharacters = atob(base64String);
    //         const byteNumbers = new Array(byteCharacters.length)
    //             .fill()
    //             .map((_, i) => byteCharacters.charCodeAt(i));
    //         const byteArray = new Uint8Array(byteNumbers);
    //         const blob = new Blob([byteArray], { type: "application/pdf" });

    //         // Create temporary download link
    //         const link = document.createElement("a");
    //         link.href = URL.createObjectURL(blob);
    //         link.download = fileName;
    //         document.body.appendChild(link);
    //         link.click();

    //         // Cleanup
    //         document.body.removeChild(link);
    //         URL.revokeObjectURL(link.href);
    //     } catch (error) {
    //         console.error("Error downloading PDF:", error);
    //         showAlert("error", "Failed to download the PDF.");
    //     }
    // };

    // ✅ Popup close handler
    const closePopup = () => setSelectedKuldeviId(null);

    return (
        <div className="bhrigu-container">
            {loading && <Loader />}
            {/* गोत्र Section */}
            <div className="section gotra-section">
                <h2 className="vertical-text">गोत्र</h2>
                <div className="list-grid">
                    {gotraList.map((item, index) => {
                        const formatText = (text) =>
                            text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";

                        return (
                            <div key={index} className="list-item">
                                <span> {formatText(item.name)}</span>{" "}<span className="devnagri">({formatText(item.hindi_name)})</span>
                            </div>
                        );
                    })}
                </div>
                <div className="download-link"
                    onClick={() => fetchGotraPdf()}
                    title="Download PDF List"
                >
                    Download List - PDF ▼</div>
            </div>

            {/* कुलदेवी Section */}
            <div className="section kuldevi-section">
                <h2 className="vertical-text">कुलदेवी</h2>
                <div className="list-grid">
                    {kuldeviList.map((item, index) => {
                        const formatText = (text) =>
                            text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : "";

                        return (
                            <div key={index} className="list-item"
                                onClick={() => setSelectedKuldeviId(item)}
                            >
                                <span> {formatText(item.name)}</span>{" "}<span className="devnagri">({formatText(item.hindi_name)})</span>
                            </div>
                        );
                    })}
                </div>
                <div className="download-link"
                    onClick={() => fetchKuldeviPdf()}
                    title="Download PDF List"
                >
                    Download List - PDF ▼</div>
            </div>

            {/* हमारी धरोहर Section */}
            <div className="section heritage-section">
                <div className="heritage-header">
                    <div className="logo-section textcenter">
                        <div>
                            <img src={bhrigu_logo} alt="Bhrigu Logo" style={{ width: '70%', margin: '0px' }} />
                        </div>
                    </div>
                    <h2 className="heritage-title">हमारी धरोहर</h2>
                </div>

                <ul className="heritage-list">
                    {heritageList.map((item, index) => (
                        <li key={index} className="heritage-item">
                            {item.title_name}
                            <span>
                                <span className="open-flipbook-link"
                                    onClick={() => window.open(item.title_url, "_blank")}
                                    title="Open Flipbook"
                                >FB</span>
                                <span className="dropdown-icon"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDownload(item);
                                    }}
                                    title="Download File"
                                >
                                    ▼
                                </span>
                            </span>
                        </li>
                    ))}
                </ul>

                {/* <div className="download-link">Download List · PDF ▼</div> */}
            </div>
            {/* ✅ Modal Popup for KuldeviProfile */}
            {selectedKuldeviId && (
                <div className="modal-overlay" onClick={closePopup}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <button className="close-btn" onClick={closePopup}>
                            ✕
                        </button>
                        {/* <KuldeviProfile kuldeviId={selectedKuldeviId} /> */}
                        <KuldeviDetails kuldeviId={selectedKuldeviId} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GotraKuldevi;
